// extracted by mini-css-extract-plugin
export var headerImage = "HeaderImg-module--header-image--6x-td";
export var headerImageFadeIn = "HeaderImg-module--header-image-fade-in--O+NPd";